import { render, staticRenderFns } from "./DraftConnectionNotice.vue?vue&type=template&id=5fdd8450&scoped=true&"
import script from "./DraftConnectionNotice.vue?vue&type=script&lang=js&"
export * from "./DraftConnectionNotice.vue?vue&type=script&lang=js&"
import style0 from "./DraftConnectionNotice.vue?vue&type=style&index=0&id=5fdd8450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdd8450",
  null
  
)

export default component.exports